import {Mutation, Action, getModule, Module} from 'vuex-module-decorators';
import store from '@/store';
import {DateTime} from 'luxon';
import {EntityModule} from './entityModule';
import {httpClient} from '@/api/baseApi';

/*
    Динамический модуль хранилища vuex для работы с анализами масел
*/

const moduleName = 'oilReportModule';

const defaultDateOptions = {locale: 'ru-RU', year: 'numeric', month: '2-digit', day: '2-digit'};

function transformGet(elem: any): any {
  return {
    ...elem,
    reportType: elem.report_type == 0 ? 'отбор' : 'замена',
    samplingDate: DateTime.fromMillis(elem.sampling_ts ?? 0).toLocaleString(defaultDateOptions),
    receptionDate: DateTime.fromMillis(elem.reception_ts ?? 0).toLocaleString(defaultDateOptions),
    reportDate: DateTime.fromMillis(elem.report_ts ?? 0).toLocaleString(defaultDateOptions),
  };
}

function transformCreateEdit(elem: any): any {
  return {
    ...elem,
    reportType: elem.report_type == 0 ? 'отбор' : 'замена',
    samplingDate: DateTime.fromMillis(elem.sampling_ts ?? 0).toLocaleString(defaultDateOptions),
    receptionDate: DateTime.fromMillis(elem.reception_ts ?? 0).toLocaleString(defaultDateOptions),
    reportDate: DateTime.fromMillis(elem.report_ts ?? 0).toLocaleString(defaultDateOptions),
  };
}

function transformSave(model: any): any {
  const rest = {...model};
  delete rest.reportType;
  delete rest.samplingDate;
  delete rest.receptionDate, delete rest.reportDate;
  const result: any = {};
  Object.keys(rest).forEach(key => {
    result[key] = rest[key] === '' ? null : rest[key];
  });
  return result;
}

@Module({
  name: moduleName,
  store: store,
  dynamic: true,
  namespaced: true,
})
export class OilReportModule extends EntityModule {
  protected oid: number | null = null;

  get routeName(): string {
    if (!this.oid) throw new Error('oid не установлен. Вызовите setOid() перед использованием');
    return `oil-nodes/${this.oid}/reports`;
  }

  @Mutation
  public setOid(_oid: number) {
    this.oid = _oid;
  }

  get all(): any[] {
    return super.all as any[];
  }

  //Получение списка объектов с сервера
  @Action({rawError: true})
  public async fetchAll() {
    return await super.fetchAll(transformGet, false);
  }

  //Получение модели для создания объекта
  @Action
  public async create(): Promise<{data: any}> {
    const transformData: any = {
      oil_node_id: 0,
      report_type: 0,
      reportType: 'отбор',
      sampling_ts: 0,
      samplingDate: '',
      reception_ts: 0,
      receptionDate: '',
      report_ts: 0,
      reportDate: '',
    };
    return {data: transformData};
  }

  //Получение модели для редактирования объекта
  @Action
  public async edit(id: any): Promise<{data: any}> {
    return super.edit(id, transformCreateEdit) as Promise<{data: any}>;
  }

  //Создание/реактирование объекта
  @Action
  public async save(model: any) {
    return super.save(model, transformSave, false);
  }

  //Импорт записей
  @Action
  public async import(formData: FormData) {
    if (!this.oid) throw new Error('oid не установлен. Вызовите setOid() перед использованием');
    try {
      const {data} = await httpClient.post(`/oil-nodes/${this.oid}/import`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return data;
    } catch (e) {
      return Promise.reject(e);
    }
  }

  //Удаление узла (в базовом классе)
}

export default getModule(OilReportModule);
